import React, { useEffect, useState } from 'react'

import moment from 'moment'

import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import './style.css'

import {
  DateRangePicker,
  SingleDatePicker,
  SingleDatePickerWrapper,
  DayPickerRangeController,
} from 'react-dates'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'

const DatePicker = (props) => {
  const [date, setDate] = useState(null)
  const [focused, setFocused] = useState(null)

  const dispatch = useDispatch()

  const displayFormat = () => {
    return date ? date.format('YYYY-MM-DD') : null
  }

  const isDayBlocked = (day) => {
    return !moment(day.format('YYYY-MM-DD')).isAfter(
      moment().format('YYYY-MM-DD')
    )
  }
  console.log('props.date', props.date)
  useEffect(() => {
    if (props.date) {
      if (props.date.isValid() && props.date !== null) {
        console.log('a po hin qitu datepicker editing')
        setDate(moment(props.date))
      }
    }
  }, [])

  // let language = props.language || {}
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  console.log(language, 'language in datepicker')
  return (
    <SingleDatePicker
      numberOfMonths={1}
      date={date}
      focused={focused}
      // placeholder={language.general ? language.general.expiration_date : null}
      placeholder={language.general ? language.general.expiration_date : null}
      displayFormat={displayFormat}
      isDayBlocked={isDayBlocked}
      block
      small
      // customInputIcon={icon}
      // showDefaultInputIcon
      // inputIconPosition='after'
      disabled={props.disabled}
      onDateChange={(date) => {
        setDate(date)
        dispatch(
          props.onDateChange(
            date ? date.utc().format('YYYY-MM-DD HH:mm:ss') : null
          )
        )
      }}
      onFocusChange={({ focused }) => setFocused(focused)}
    />
  )
}

export default DatePicker

// import React, { useState, useEffect } from 'react'
// import { useDispatch } from 'react-redux'
// import moment from 'moment'
// import { SingleDatePicker } from 'react-dates'

// const DatePicker = (props) => {
// 	const [date, setDate] = useState(null)
// 	const [focused, setFocused] = useState(null)
// 	const dispatch = useDispatch()

// 	const displayFormat = () => {
// 		return date ? date.format('YYYY-MM-DD') : null
// 	}

// 	const isDayBlocked = (day) => {
// 		return !moment(day.format('YYYY-MM-DD')).isAfter(
// 			moment().format('YYYY-MM-DD')
// 		)
// 	}

// 	useEffect(() => {
// 		if (props.date && props.date.isValid() && props.date !== null) {
// 			setDate(moment(props.date))
// 		}
// 	}, [props.date])

// 	let language = props.language || {}

// 	const handleDateChange = (selectedDate) => {
// 		setDate(selectedDate)
// 		dispatch(
// 			props.onDateChange(
// 				selectedDate ? selectedDate.utc().format('YYYY-MM-DD HH:mm:ss') : null
// 			)
// 		)
// 	}

// 	return (
// 		<SingleDatePicker
// 			numberOfMonths={1}
// 			date={date}
// 			focused={focused}
// 			placeholder={language.general ? language.general.expiration_date : null}
// 			displayFormat={displayFormat}
// 			isDayBlocked={isDayBlocked}
// 			block
// 			small
// 			// customInputIcon={icon}
// 			// showDefaultInputIcon
// 			// inputIconPosition='after'
// 			disabled={props.disabled}
// 			onDateChange={handleDateChange}
// 			onFocusChange={({ focused }) => setFocused(focused)}
// 		/>
// 	)
// }

// export default DatePicker
